import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePickerProps,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  input: {
    color: theme.palette.primary.main,
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
}));

const resolveDateValue = (raw: unknown): Date | null => {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw;
  }
  if (typeof raw !== 'string') {
    return null;
  }
  const trimmed = raw.trim();
  const brMatch = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (brMatch) {
    const day = Number(brMatch[1]);
    const month = Number(brMatch[2]);
    const year = Number(brMatch[3]);
    return new Date(year, month - 1, day);
  }
  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/**
 * Date picker controlado pelo valor do formulário pai.
 */
export default function TextDate(props: KeyboardDatePickerProps): JSX.Element {
  const classes = useStyles();
  const { onChange, value, required, inputProps, InputLabelProps, ...rest } = props;

  return (
    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
      <KeyboardDatePicker
        fullWidth
        autoOk
        variant="inline"
        inputVariant="outlined"
        label="With keyboard"
        format="dd/MM/yyyy"
        InputProps={{
          className: classes.input,
        }}
        className={classes.textField}
        InputAdornmentProps={{ position: 'end' }}
        {...rest}
        InputLabelProps={{ ...InputLabelProps, required: Boolean(required) }}
        inputProps={{ ...inputProps, required: undefined }}
        value={resolveDateValue(value)}
        onChange={(date: Date | null) => {
          if (onChange) {
            onChange(date);
          }
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
